import { motion } from 'framer-motion';
import { Zap, Link2, Trophy, Globe } from 'lucide-react';

export function Advantages() {
  const openChat = () => {
    const chatButton = document.querySelector('[data-chat-trigger]') as HTMLButtonElement;
    if (chatButton) {
      chatButton.click();
    }
  };

  const advantages = [
    {
      icon: Zap,
      title: '技术创新驱动',
      description: '构建JAVA/.NET/SaaS三大技术平台，融合数据中台与AI技术，实现业务敏捷开发',
      color: 'from-orange-600 to-yellow-400',
      bgColor: 'from-orange-50 to-yellow-50',
    },
    {
      icon: Link2,
      title: '全链服务能力',
      description: '覆盖跨境物流、电子商务、智慧健康三大领域，提供"咨询+规划+产品+实施"一体化解决方案',
      color: 'from-red-600 to-orange-400',
      bgColor: 'from-red-50 to-orange-50',
    },
    {
      icon: Trophy,
      title: '行业标杆案例',
      description: '服务中国铁建、UPS中国、中免集团等500强企业，打造斑马物联网、嘉谷万邑等知名品牌系统',
      color: 'from-yellow-600 to-orange-400',
      bgColor: 'from-yellow-50 to-orange-50',
    },
    {
      icon: Globe,
      title: '全国布局网络',
      description: '1+10城市战略覆盖，提供本地化服务支持，确保快速响应客户需求',
      color: 'from-orange-500 to-red-500',
      bgColor: 'from-orange-50 to-red-50',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 via-orange-50 to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-block px-4 py-1 rounded-full bg-orange-100 text-orange-600 text-sm mb-4">
            核心优势
          </div>
          <h2 className="text-gray-900 mb-4">为什么选择越亘科技</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            凭借深厚的技术积累和丰富的行业经验，为企业提供卓越的数字化转型服务
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {advantages.map((advantage, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative"
            >
              <div className="relative p-8 rounded-2xl bg-white border border-gray-200 hover:border-transparent hover:shadow-2xl transition-all duration-300 overflow-hidden">
                {/* Background Gradient on Hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${advantage.bgColor} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
                
                <div className="relative z-10">
                  {/* Icon */}
                  <div className={`inline-flex w-16 h-16 rounded-xl bg-gradient-to-br ${advantage.color} items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <advantage.icon className="text-white" size={28} />
                  </div>

                  {/* Content */}
                  <h3 className="text-gray-900 mb-4">{advantage.title}</h3>
                  <p className="text-gray-600 leading-relaxed">
                    {advantage.description}
                  </p>

                  {/* Decorative Element */}
                  <div className={`mt-6 w-12 h-1 rounded-full bg-gradient-to-r ${advantage.color} group-hover:w-24 transition-all duration-300`}></div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-16 text-center"
        >
          <div className="inline-flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-8 p-6 sm:p-8 rounded-2xl bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 text-white max-w-3xl mx-auto">
            <div className="text-center sm:text-left">
              <div className="text-xl sm:text-2xl mb-2">准备开启数字化转型之旅？</div>
              <div className="text-yellow-100 text-sm sm:text-base">让我们一起探讨您的业务需求</div>
            </div>
            <button
              onClick={openChat}
              className="px-6 sm:px-8 py-3 rounded-full bg-white text-orange-600 hover:bg-gray-100 transition-colors whitespace-nowrap flex-shrink-0"
            >
              免费咨询
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}